import { applyExtensions } from "./extend.js";
export function extendArray(array, ...extensions) {
    return applyExtensions(array, extensions);
}
//# sourceMappingURL=extend-array.js.map